import '../styles/Hero.css';
import banner from '../assets/img/bg-home.jpg';

function HomeHero() {

  return (
    <>
      <div className='banner-hero banner-hero-home'>
        <img src={banner} alt='AbbVie Accès Dérogatoires' />
        <div className='entry-header'>
          <h1>Bienvenue sur le site AbbVie <br/> dédié à nos <strong>Accès Dérogatoires</strong></h1>
          <p>AbbVie est une entreprise biopharmaceutique fondée sur la recherche et l'innovation. Notre mission&nbsp;: mettre à disposition nos expertises, nos ressources humaines et une approche unique de l'innovation pour développer des thérapies innovantes qui répondent à des maladies chroniques et/ou complexes et graves, et transforment la vie des patients, dans 5 aires thérapeutiques majeures : l'immunologie, l'onco-hématologie, les neurosciences, la virologie et les soins oculaires.</p>
        </div>
      </div>
    </>
  )
}

export default HomeHero